'use client';
import { getCookie } from 'cookies-next';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import { useProperty } from '@/forApp/states/propertyState/propertyState';
import { useUser } from '@/forApp/states/userState/userState';
import Button from '@/shared/Buttons/Button';
import { Icons } from '@/shared/Icons/Icons';
import Logo from '@/shared/Logo/Logo';
import MobileMenu from '@/widgets/MoileMenu/MobileMenu';
import { ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

const HeaderMobile = () => {
  const { user, getUser } = useUser();
  const { addModal, toggleIsMobile, isOpenMobileMenu, toggleIsOpenMobileMenu } =
    useApp();

  const router = useRouter();
  const { fetchTypes, types } = useProperty();

  useEffect(() => {
    toggleIsMobile(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpenMobileMenu) {
      const scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      const scrollY = document.body.style.top;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [isOpenMobileMenu]);

  const token = getCookie('cg-token');

  useEffect(() => {
    if (!user && token) getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user]);

  useEffect(() => {
    if (!types.length) fetchTypes().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [types.length]);

  const onOpen = () => {
    const token = getCookie('cg-token');
    if (token) router.push(ROUTES.ADD);
    else addModal({ name: 'AuthModal', type: 'login' });
  };

  const onToggleMenu = () => {
    if (!isOpenMobileMenu) {
      window.scrollTo(0, 0);
    }
    toggleIsOpenMobileMenu(!isOpenMobileMenu);
  };

  return (
    <header className={styles.header}>
      <Logo isMobile={true} color={'black'} />
      <div className={styles.blockBtn}>
        <Button
          text={'Разместить объявление'}
          color={'white'}
          onClick={onOpen}
          className={styles.btnCreate}
        />
        <Button
          color={'white'}
          size={'icnSm'}
          variant={'outline'}
          icon={isOpenMobileMenu ? <Icons.Close /> : <Icons.Menu />}
          onClick={onToggleMenu}
        />
      </div>
      {isOpenMobileMenu ? <MobileMenu /> : null}
    </header>
  );
};

export default HeaderMobile;
